/**
 * bundle-cart-cleanup.js
 * Automatically removes orphaned "Free Gift" items from the cart if their parent bundle is removed.
 * Listens to all cart AJAX requests to work seamlessly with native logic and 3rd-party apps like Kaching Cart.
 */
(function () {
    if (window.bundleCleanupInitialized) return;
    window.bundleCleanupInitialized = true;

    let isFixingCart = false;

    function handleCartResponse(cart) {
        // Only proceed if it's a valid cart object with items
        if (!cart || !Array.isArray(cart.items) || isFixingCart) return;

        const bundleKeysInCart = new Set();

        // 1. Identify all parent bundles in the cart
        cart.items.forEach(item => {
            if (item.properties && item.properties['_BundleKey'] && !item.properties['_Gift']) {
                bundleKeysInCart.add(item.properties['_BundleKey']);
            }
        });

        const updates = {};
        let hasOrphans = false;

        // 2. Identify orphaned gifts (gifts whose _BundleKey parent is no longer in the cart)
        cart.items.forEach(item => {
            if (item.properties && item.properties['_Gift'] === 'Free Gift') {
                const bKey = item.properties['_BundleKey'];
                if (!bKey || !bundleKeysInCart.has(bKey)) {
                    // Mark for removal
                    updates[item.key] = 0;
                    hasOrphans = true;
                }
            }
        });

        // 3. Remove orphaned gifts via /cart/update.js
        if (hasOrphans) {
            isFixingCart = true;
            console.log('Bundle Cleanup: Orphaned free gifts detected, removing...');

            fetch(window.Shopify && window.Shopify.routes ? (window.Shopify.routes.root + 'cart/update.js') : '/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates })
            })
                .then(res => res.json())
                .then(newCart => {
                    isFixingCart = false;
                    console.log('Bundle Cleanup: Cart fixed.');

                    // Dispatch theme-specific events to trigger UI re-renders
                    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
                    document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));

                    // Kaching Cart and other apps usually automatically intercept this explicit fetch, 
                    // so their UI should automatically reflect the new cart state.
                })
                .catch(e => {
                    console.error('Bundle Cleanup Error:', e);
                    isFixingCart = false;
                });
        }
    }

    // Intercept Fetch API
    const originalFetch = window.fetch;
    window.fetch = async function () {
        const response = await originalFetch.apply(this, arguments);
        const url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];

        // We only care about cart fetches/mutations
        if (url && typeof url === 'string' && url.includes('/cart')) {
            const clone = response.clone();
            clone.json().then(data => {
                if (data && data.items) {
                    handleCartResponse(data);
                }
            }).catch(e => { /* ignore json parse errors for non-json responses */ });
        }

        return response;
    };

    // Intercept XMLHttpRequest
    const originalXHRSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.send = function () {
        this.addEventListener('load', function () {
            if (this.responseURL && this.responseURL.includes('/cart')) {
                try {
                    const data = JSON.parse(this.responseText);
                    if (data && data.items) {
                        handleCartResponse(data);
                    }
                } catch (e) { }
            }
        });
        return originalXHRSend.apply(this, arguments);
    };
})();
